import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { CoreResponse } from '../models/core-response';
import { SellerSnapshotField } from '../models/seller-snapshot-field';
import { SellerSnapshotChangesContext } from '../models/contexts/seller-snapshot-changes-context';
import { HistSellerAuditResults } from '../models/hist-seller-audit-results';
import { SellerLayout } from '../models/seller-layout';
import { SellerSnapshotDatasourceContext } from '../models/contexts/seller-snapshot-datasource-context';
import { Xaction } from '../models/xaction';

@Injectable()
export class SellerSnapshotService {
    private url: string = environment.apiEndpoint + '/sellerSnapshot';

    constructor(private http: HttpClient) {
    }

    getSellerSnapshotFields(): Observable<CoreResponse<SellerSnapshotField>> {
        return this.http.get<CoreResponse<SellerSnapshotField>>(this.url + '/snapshotFields');
    }

    getSellerLayouts(): Observable<CoreResponse<SellerLayout>> {
        return this.http.get<CoreResponse<SellerLayout>>(this.url + '/layouts');
    }

    getSnapshotDatasource(context: SellerSnapshotDatasourceContext): Observable<CoreResponse<any>> {
        return this.http.post<CoreResponse<any>>(this.url + '/datasource', context);
    }

    insertSellerLayout(sellerLayout: SellerLayout): Observable<CoreResponse<SellerLayout>> {
        return this.http.post<CoreResponse<SellerLayout>>(this.url + '/layout', sellerLayout);
    }

    updateSellerSnapshotFields(context: SellerSnapshotChangesContext): Observable<CoreResponse<HistSellerAuditResults>> {
        return this.http.post<CoreResponse<HistSellerAuditResults>>(this.url + '/updateSnapshot', context);
    }

    updateSellerLayout(sellerLayout: SellerLayout): Observable<CoreResponse<SellerLayout>> {
        return this.http.put<CoreResponse<SellerLayout>>(this.url + '/layout', sellerLayout);
    }

    deleteSellerLayout(sellerLayoutId: number): Observable<CoreResponse<number>> {
        return this.http.delete<CoreResponse<number>>(this.url + '/layout/' + sellerLayoutId.toString());
    }
}
